module.exports = __webpack_public_path__ + "media/images/communities/logos/ao1-3601e8cd2c4f51cafbc573933b8b3df4.png";